import { Event } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";

export class ChunkRangeChangeEvent extends Event {
    chunkRange: Chunk[];

    constructor( chunkRange: Chunk[] ) {
        super( { eventType: ChunkRangeChangeEvent.getEventType() } );

        this.chunkRange = chunkRange;
    }

    static getEventType() {
        return 'chunkRangeChange';
    }

    destroy() {
        this.chunkRange = null;
        super.destroy();
    }
}